import React from "react";
import {
  House,
  DoorOpen,
  Lock,
  WifiHigh,
  Waves,
  Bathtub,
  Flame,
  Fire,
  Bicycle,
  Prohibit,
  Scroll,
  ForkKnife,
  MapTrifold,
  SunHorizon,
  Key,
  Car,
  Wine,
  Trophy,
  ClipboardText,
  TennisBall,
  FirstAidKit,
  Phone,
  Warning,
} from "@phosphor-icons/react";

const MAP = {
  House,
  DoorOpen,
  Lock,
  WifiHigh,
  Waves,
  Bathtub,
  Flame,
  Fire,
  Bicycle,
  Prohibit,
  Scroll,
  ScrollText: Scroll,
  ForkKnife,
  MapTrifold,
  SunHorizon,
  Key,
  Car,
  Wine,
  Trophy,
  ClipboardText,
  TennisBall,
  FirstAidKit,
  Phone,
  Warning,
};

export default function Icon({ name, ...props }) {
  const Cmp = MAP[name] || House;
  return <Cmp {...props} />;
}

export const ICON_OPTIONS = Object.keys(MAP).filter((k) => k !== "ScrollText");
